import React, { FC } from 'react';
import styled from 'styled-components';

import App from '../../../models/app';
import { ClockCard } from '../ClockCard';

const RowItem = styled.div`
  width: calc(33% - 22.5px);
  text-align: center;
  margin-bottom: 10px;
`;

interface ClockProps {
  clock: App;
  selected: boolean;
  collectionId?: string;
}

export const ClockRowItem: FC<ClockProps> = ({ clock, selected, collectionId }) => {
  const [banner] = clock.banners;
  return (
    <RowItem>
      <ClockCard
        id={clock.id}
        rating={clock.ratingSummary}
        name={clock.name}
        screenshot={banner}
        showRatings={clock.showRatings}
        isPremium={clock.isPremium}
        isInstalled={selected}
        collectionId={collectionId}
      />
    </RowItem>
  );
};